import { ReactNode } from 'react'

type EntryFormCardProps = {
  prompt: ReactNode
  children: ReactNode
  'data-testid'?: string
}

const EntryFormCard = (props: EntryFormCardProps): JSX.Element => {
  return (
    <div className="z-[2] w-full max-w-[508px] rounded-2xl bg-neutral-100 p-4" data-testid={props['data-testid']}>
      <div className="bg-secondary-200 -mx-4 -mt-4 rounded-t-2xl p-6">
        <h1 className="typography-h4 font-semibold text-neutral-800">{props.prompt}</h1>
      </div>
      <div className="px-2 pt-5">{props.children}</div>
    </div>
  )
}

export default EntryFormCard
